import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { indexBy, pathOr, prop } from 'ramda'
import { convertData } from '@lib/services'
import { IIsoAssessmentType } from './options.type'

type IsoAssessmentTypesById = Record<string, IIsoAssessmentType>

export const useIsoAssessmentTypes = () => {
  const { data, refetch, isFetching } = useQuery<IIsoAssessmentType[]>([
    '/options/isoAssessmentTypes',
  ])

  const dataSource = useMemo(
    () =>
      convertData<IIsoAssessmentType>(
        {
          field: ['data'],
          converter: x => ({
            ...x,
            longDesc: `${x.mainType}.${x.subType} ${x.desc}`,
          }),
        },
        data
      ),
    [data]
  )

  const byId = useMemo<IsoAssessmentTypesById>(() => {
    return indexBy(x => String(prop('value', x)), pathOr([], ['content'], dataSource))
  }, [dataSource])

  return {
    data: pathOr([], ['content'], dataSource),
    dataSource,
    isLoading: isFetching,
    refetch,
    byId,
  }
}
